<template>
    <div class="calendar">
        <div class="calendar-controls">
            <button class="control-button" @click="prevMonth">&lt;</button>
            <div class="month-display">{{ displayMonth }}</div>
            <button class="control-button" @click="nextMonth">&gt;</button>
        </div>

        <div class="weekdays">
            <div class="weekday" v-for="day in weekdayNames" :key="day">{{ day }}</div>
        </div>

        <div class="days">
            <div v-for="(day, index) in visibleDays" :key="index" :class="[
                'day',
                { 'current-month': day.isCurrentMonth },
                { 'today': day.isToday },
                { 'weekend': day.isWeekend },
                { 'selected': isSelected(day.date) }
            ]" @click="handleSelectDay(day)">
                <span class="day-number">{{ day.date.getDate() }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VueCalendar',
    // props: {
    //     selectedDate: {
    //         type: Date,
    //         default: null
    //     }
    // },
    data() {
        return {
            currentDate: new Date(),
            weekdayNames: ['一', '二', '三', '四', '五', '六', '日'],
            selectedDate: undefined
        }
    },
    computed: {
        displayMonth() {
            return `${this.currentDate.getFullYear()}年 ${this.currentDate.getMonth() + 1}月`
        },
        visibleDays() {
            const year = this.currentDate.getFullYear()
            const month = this.currentDate.getMonth()

            // 当月第一天和最后一天
            const firstDay = new Date(year, month, 1)
            const lastDay = new Date(year, month + 1, 0)

            // 计算需要显示的上个月天数
            const firstDayOfWeek = firstDay.getDay() || 7 // 转换周日(0)为7
            const prevMonthDays = firstDayOfWeek - 1 // 周一为1，需要减1

            // 计算需要显示的下个月天数
            const totalDays = lastDay.getDate() + prevMonthDays
            const remainingDays = totalDays % 7
            const nextMonthDays = remainingDays ? 7 - remainingDays : 0

            const days = []
            const today = new Date()
            today.setHours(0, 0, 0, 0)

            // 添加上个月的日期
            if (prevMonthDays > 0) {
                const prevMonthLastDay = new Date(year, month, 0).getDate()
                for (let i = prevMonthDays; i > 0; i--) {
                    const date = new Date(year, month - 1, prevMonthLastDay - i + 1)
                    days.push(this.createDayObject(date, false))
                }
            }

            // 添加当月的日期
            for (let i = 1; i <= lastDay.getDate(); i++) {
                const date = new Date(year, month, i)
                days.push(this.createDayObject(date, true))
            }

            // 添加下个月的日期
            for (let i = 1; i <= nextMonthDays; i++) {
                const date = new Date(year, month + 1, i)
                days.push(this.createDayObject(date, false))
            }

            return days
        }
    },
    methods: {
        createDayObject(date, isCurrentMonth) {
            const today = new Date()
            today.setHours(0, 0, 0, 0)

            return {
                date,
                isCurrentMonth,
                isToday: date.getTime() === today.getTime(),
                isWeekend: date.getDay() === 0 || date.getDay() === 6
            }
        },
        prevMonth() {
            this.currentDate = new Date(
                this.currentDate.getFullYear(),
                this.currentDate.getMonth() - 1,
                1
            )
        },
        nextMonth() {
            this.currentDate = new Date(
                this.currentDate.getFullYear(),
                this.currentDate.getMonth() + 1,
                1
            )
        },
        handleSelectDay(day) {
            console.log("day", day)
            if (!day.isCurrentMonth) {
                return
            }
            this.selectedDate = new Date(day.date)
            // this.$emit('update:selectedDate', new Date(day.date))
        },
        isSelected(date) {

            if (!this.selectedDate) return false

            return (
                date.getDate() === this.selectedDate.getDate() &&
                date.getMonth() === this.selectedDate.getMonth() &&
                date.getFullYear() === this.selectedDate.getFullYear()
            )
        }
    }
}
</script>

<style scoped>
.calendar {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.calendar-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background-color: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
}

.month-display {
    font-size: 16px;
    font-weight: 500;
    color: #212529;
}

.control-button {
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    color: #495057;
    transition: background-color 0.2s;
}

.control-button:hover {
    background-color: #e9ecef;
}

.weekdays {
    display: flex;
    background-color: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
}

.weekday {
    flex: 1;
    text-align: center;
    padding: 8px 0;
    font-size: 14px;
    color: #495057;
    font-weight: 500;
}

.days {
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
}

.day {
    width: calc(100% / 7);
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
}

.day-number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    font-size: 14px;
}

/* .current-month .day-number {
  color: #212529;
} */

.current-month:not(.today):hover .day-number {
    background-color: #f1f3f5;
}

.today .day-number {
    background-color: #1971c2;
    color: white;
    font-weight: 500;
}

.weekend {
    color: #f03e3e;
}

.day:not(.current-month) {
    color: #adb5bd;
}

.day:not(.current-month).weekend {
    color: #ffc9c9;
}

.selected .day-number {
    background-color: #e9ecef;
    font-weight: 500;
    box-shadow: 0 0 0 2px #1971c2 inset;
}
</style>